export default "__VITE_ASSET__CfGVjhX0__"